import { GetArticlesById } from "../api/viewgres_v4";
import form from "./form";
import { PutArticle } from "../api";
import { ShowApiError } from "@/request/error";
export default {
  mixins: [form],
  data() {
    return {};
  },
  computed: {},
  methods: {
    buildTableColumns(columns = []) {
      if (columns.length > 0) {
        this.tableColumns = columns;
      } else {
        this.tableColumns = [
          {
            prop: "titleCn",
            label: "中文名",
            minWidth: 150,
            showColumn: true,
            align: "left",
            fixed: "left",
            sortable: "custom"
          },
          {
            prop: "description_image_url",
            label: "封面图",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "utc_post",
            label: "发布日期",
            minWidth: 150,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },

          {
            prop: "titleEn",
            label: "英文名",
            minWidth: 150,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "description",
            label: "描述",
            minWidth: 150,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },

          {
            prop: "poster_image_url",
            label: "海报图",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "tags",
            label: "标签",
            minWidth: 150,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "content",
            label: "内容",
            minWidth: 120,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "seq",
            label: "次序",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "id",
            label: "ID",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "vgc_article_id",
            label: "唯格云文章ID",
            width: 150,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "utc_create",
            label: "创建日期",
            showColumn: true,
            width: 200,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "user_name_create",
            label: "创建人",
            showColumn: true,
            minWidth: 150,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "utc_modified",
            label: "更新日期",
            showColumn: true,
            width: 200,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "user_name_modified",
            label: "更新人",
            showColumn: true,
            align: "center",
            minWidth: 150,
            sortable: "custom"
          },
          {
            prop: "disabled",
            label: "状态",
            showColumn: true,
            width: 100,
            align: "center",
            fixed: null,
            sortable: "custom"
          },
          {
            prop: "controlColumn",
            fixed: "right",
            align: "center",
            showColumn: true,
            label: "操作",
            width: 100
          }
        ];
      }
    },
    updateByVgcId(row) {
      if (row.vgc_article_id == null) {
        this.$message.error("请先绑定唯格云文章");
        return;
      }

      this.$msgbox({
        title: "提示",
        message: `是否确定将[${row.title.cn}]与唯格云文章同步?`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            try {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "开始同步...";
              const { data } = await GetArticlesById(row.vgc_article_id);
              let formData = this.buildFormItem();
              instance.confirmButtonText = "正在构建表单...";
              formData = this.buildFormByVgcItem(data);
              // formData.title = { cn: data.title, en: data.title };
              // formData.post_at = data.postMillisecond;
              // formData.description = {
              //   cn: data.descriptionText,
              //   en: data.descriptionText
              // };
              // formData.description_image_url = replaceCdnAddress(
              //   data.description_image_url
              // );
              // formData.content = { cn: data.content, en: data.content };
              // formData.reference_url = data.referenceUrl;
              // formData.poster_image_url = replaceCdnAddress(data.poster_image_url);
              // formData.poster_slogan = {
              //   cn: data.posterSlogan,
              //   en: data.posterSlogan
              // };
              // formData.tag_ids = [this.typeMaper[data.typeId]];
              // formData.vgc_article_id = data.id;
              // formData.seq = 1;
              instance.confirmButtonText = "正在覆盖数据...";
              await PutArticle([
                {
                  id: row.id,
                  ...formData
                }
              ]);
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "同步完成";
              this.$message.success("同步完成");
              done();
            } catch (error) {
              ShowApiError("同步失败", error);
              done();
              return;
            }
          } else {
            done();
          }
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "取消"
        });
      });
    }
  }
};
